<template>
  <div class="container-one">
    <!-- 顶部菜单 -->
    <div class="header-box" @click="toVehicleDetail">
      <img class="img" src="@/assets/maintain/vehicle_icon.png" alt="" />
      车辆配置
    </div>
    <!-- 推荐油品 -->
    <div class="recommend-box">
      <div class="recommend-title">
        <div class="title-left">刹车油推荐</div>
      </div>
      <!-- 油品列表 -->
      <div class="recommend-list" v-if="goods_list.length > 0">
        <div
          class="recommend-item"
          v-for="(item, index) in goods_list"
          :key="index"
          @click="goDetail(item)"
        >
          <img class="goods-img" :src="item.url" alt="" />
          <div class="recommend-item-info">
            <div
              class="desc-box double-line-ellipses"
              style="-webkit-line-clamp: 3"
            >
              <img
                v-if="item.is_best_goods == 1"
                class="best-icon"
                src="@/assets/maintain/best_icon.png"
                alt=""
              />
              <div class="info-desc">
                {{ item.name }}
              </div>
            </div>
            <div class="go-detail-box">
              查看详情
              <img
                class="arrow-right"
                src="@/assets/maintain/arrow_right.png"
                alt=""
              />
            </div>
          </div>
        </div>
      </div>
      <!-- 无机油推荐缺省展示 -->
      <div class="no-products" v-else>
        <img
          src="@/assets/maintain/no_oil_empty.png"
          alt=""
          class="empty-icon"
        />
        <div class="tip">暂无刹车油推荐</div>
        <div class="reselect-button" @click="back">重新选择其他车辆</div>
      </div>
    </div>
  </div>
</template>
<script>
import api from "@/apis/maintenance-api";
import { setStatistics } from "@/utils/common/index.js";
import { userQueryCarModelRecord } from "@/utils/data-burial";
export default {
  name: "BrakingSystem",
  props: {
    query: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      goods_list: [],
    };
  },
  async mounted() {
    this.vehicle_id = this.query.vehicle_id || "";
    await this.getMaintenance();
    await this.queryDataRecord();
  },
  methods: {
    // 去机油商品详情
    goDetail(params) {
      const OILSHARE = sessionStorage.getItem("OILSHARE");
      if (JSON.parse(OILSHARE).goods_jump_status !== 1) return;
      this.$router.push({
        path: "/maintenance-good",
        query: {
          goods_id: params.id,
          scheme_id: this.query.scheme_id,
        },
      });
    },
    /**
     * 跳转车辆配置详情
     */
    toVehicleDetail() {
      this.$router.push({
        path: "/maintenance-config",
        query: { vehicle_id: this.vehicle_id },
      });
    },
    // 获取推荐刹车油商品列表
    async getMaintenance() {
      let self = this;
      let loading = this.$loading;
      loading.show("加载中...");
      const params = {
        vehicle_id: this.vehicle_id,
        type: 2,
        scheme_id:
          this.query.scheme_id || window.sessionStorage.getItem("OILVERSION"),
      };
      try {
        const res = await api.getOilRecommendGoodsListApi(params);
        loading.hide();
        this.loadData = true;
        if (res.code == 0) {
          this.goods_list = res.data.goods_list;
        } else {
          self.$toast.show({
            showTime: 2,
            message: res.message,
            style: "error",
          });
        }
        this.loadData = true;
      } catch (error) {
        console.log("获取刹车油推荐商品失败", error);
      }
    },
    back() {
      this.$router.push({
        path: "/home",
        query: {
          id:
            this.query.scheme_id || window.sessionStorage.getItem("OILVERSION"),
        },
      });
    },
    // 查询数据记录
    async queryDataRecord() {
      console.log(localStorage.getItem("OILUSER"));
      if (!localStorage.getItem("OILUSER")) {
        await setStatistics.apply(this, []);
      }
      const uuid = localStorage.getItem("OILUSER");
      const { internal_from, vehicle_id } = this.query;
      const basic_info = {
        choose_vehicle_id: vehicle_id,
        menu_type: 5,
        uuid,
        scheme_id: this.query.scheme_id || this.query.id,
        search_type:
          internal_from === "photo_vin"
            ? 2
            : internal_from === "text_vin"
            ? 3
            : 1,
      };
      let goods_info = {};
      if (this.goods_list.length > 0) {
        const engine_oil_goods_list = this.goods_list;
        const high_temp = engine_oil_goods_list.filter(
          (i) => i.is_best_goods === 1
        )[0];
        const low_temp = engine_oil_goods_list.filter(
          (i) => i.is_best_goods === 0
        )[0];
        goods_info = {
          goods_low_mid: low_temp ? low_temp.mid : "",
          goods_low_name: low_temp ? low_temp.name : "",
          goods_high_mid: high_temp ? high_temp.mid : "",
          goods_high_name: high_temp ? high_temp.name : "",
        };
      }
      await userQueryCarModelRecord.apply(this, [basic_info, goods_info]);
    },
  },
};
</script>
<style lang="less" scoped>
.container-one {
  .header-box {
    display: flex;
    align-items: center;
    width: 100%;
    height: 85/100rem;
    border-radius: 20/100rem;
    background: linear-gradient(180deg, #fbd119 0%, #fbc207 100%);
    box-shadow: 0px 3/100rem 20/100rem 0px rgba(251, 220, 106, 1);
    padding: 20/100rem 43/100rem 24/100rem;
    margin-bottom: 27/100rem;
    font-size: 24/100rem;
    color: #333;
    .img {
      width: 41/100rem;
      height: 41/100rem;
      margin-right: 3/100rem;
    }
  }
  .recommend-box {
    margin-bottom: 34/100rem;
    padding: 24/100rem 27/100rem 26/100rem;
    background: #ffffff;
    box-shadow: 0px 10/100rem 27/100rem 0px rgba(207, 207, 207, 0.2);
    border-radius: 20/100rem;
    .recommend-title {
      display: flex;
      justify-content: space-between;
      align-items: center;
      .title-left {
        font-size: 27/100rem;
        color: #333;
        font-weight: bolder;
      }
      .title-right {
        display: flex;
        font-size: 20/100rem;
        color: #666;
        .litre {
          color: #fbc60c;
        }
      }
    }
    .recommend-list {
      .recommend-item {
        display: flex;
        // justify-content: space-between;
        margin: 26/100rem auto;
        .goods-img {
          width: 123/100rem;
          height: 123/100rem;
          border-radius: 9/100rem;
          margin-right: 17/100rem;
        }
        .recommend-item-info {
          display: flex;
          flex-direction: column;
          justify-content: space-between;
          flex: 1;
          .desc-box {
            .best-icon {
              float: left;
              vertical-align: baseline;
              width: 41/100rem;
              height: 24/100rem;
              margin-top: 4/100rem;
              margin-right: 4/100rem;
            }
            .info-desc {
              font-size: 20/100rem;
              line-height: 34/100rem;
            }
          }
          .go-detail-box {
            align-self: flex-end;
            display: flex;
            align-items: center;
            color: #fbc409;
            font-size: 17/100rem;
            .arrow-right {
              width: 10/100rem;
              height: 15/100rem;
              margin-left: 7/100rem;
            }
          }
        }
      }
    }
    // 无机油推荐展示
    .no-products {
      display: flex;
      flex-direction: column;
      align-items: center;
      margin: 0 auto;
      .empty-icon {
        width: 133/100rem;
        height: 133/100rem;
        margin-bottom: 10/100rem;
      }
      .tip {
        color: #666666;
        font-size: 24/100rem;
        margin-bottom: 27/100rem;
      }
      .reselect-button {
        width: 246/100rem;
        height: 55/100rem;
        background: linear-gradient(180deg, #fbd119 0%, #fbc207 100%);
        box-shadow: 0px 3/100rem 20/100rem 0px rgba(251, 220, 106, 1);
        border-radius: 40/100rem;
        display: flex;
        align-items: center;
        justify-content: center;
        font-weight: bold;
        color: #333333;
        font-size: 24/100rem;
        margin-bottom: 55/100rem;
      }
    }
  }
}
</style>
